import { sShowScreen, sBannerStep, sBanner, sAutocompleteListSetup, sResetAutocomplete, sCurrencyFormatter } from "../../shared.min.js";

const visaTool = {
	widget: document.getElementById("visa-tool"),
	cmsValues: document.getElementById('visa-tool-cms-values'),
	tripInput: document.getElementById("visa-tool-trip-input"),
	continueButton: document.getElementById("visa-tool-submit"),
	autocompleteList: document.getElementById("visa-tool-autocomplete"),
	autoCompleteSelected: document.getElementById("visa-tool-autocompleteSelected"),
	restartButton: document.getElementById("visa-restart-button"),
	downloadButton: document.getElementById("visa-download-button"),

	screens: null,

	jsonData: {},

	//accordion
	templateAccordion: document.getElementById("visa-tool-accordion-template"),
	templatePdfListItem: document.getElementById("visa-tool-pdf-row-template"),
	accordionContainer: null,
	pdfContentContainer: null,

	visaWarningTitle: null,
	visaWarningText: null,

	autoCompleteListItems: null,
	selectedItemsArray: [],

	travelAdvisedTitle: "",
	travelInadvisedTitle: "",
	travelAdvisedContent: "",


	init: async function () {
		this.getElements();
		this.setEListeners();
		this.setUpBanner();

		await this.getJsonData();

		this.initAutocomplete();
	},

	getElements: function () {
		this.visaRequiredText = this.widget?.querySelector("[data-visa-isRequired-text]");

		this.accordionContainer = this.widget?.querySelector(".mod-details-accordion__container");
		this.pdfContentContainer = this.widget?.querySelector(".visa-tool__pdf__content");

		//screens
		this.screens = this.widget?.querySelectorAll('.widget__screen'),

			// FCDO warning
			this.visaWarningText = this.widget?.querySelector("[data-visa-warning-content]");
		this.visaWarningTitle = this.widget?.querySelector("[data-visa-warning-title]");

		this.travelAdvisedTitle = this.cmsValues.getAttribute("data-visa-travel-no-warning-title");
		this.travelInadvisedTitle = this.cmsValues.getAttribute("data-visa-travel-warning-title");
		this.travelAdvisedContent = this.cmsValues.getAttribute("data-visa-travel-no-warning-content");
	},

	setUpBanner: function () {
		const bannerText1 = this.cmsValues.getAttribute("data-visa-banner-title-1");
		const bannerText2 = this.cmsValues.getAttribute("data-visa-banner-title-2");

		sBanner(
			this.widget,
			[bannerText1, bannerText2],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			1
		);
	},


	getJsonData: async function () {
		const jsonLinkUrl = this.cmsValues.getAttribute("data-visa-json-data");

		if (!jsonLinkUrl) return;

		try {
			const response = await fetch(jsonLinkUrl);
			this.jsonData = await response.json();
		} catch (error) {
			console.error('Error fetching JSON data:', error);
		}
	},

	setEListeners: async function () {
		this.continueButton.addEventListener('click', (e) => {
			this.handleButtonClick();
			sBannerStep(2);
			sShowScreen(this.screens, 2);
		});

		this.restartButton.addEventListener('click', (e) => {
			this.resetWidget();
		});

		this.downloadButton.addEventListener('click', async e => {
			e.preventDefault();
			await this.generatePDF();
		});
	},

	initAutocomplete: function () {

		if (!this.jsonData || !Array.isArray(this.jsonData)) {
			console.error("Autocomplete failed: jsonData is missing or invalid.");
			return;
		}
		const { selectedItemsArray } = sAutocompleteListSetup({
			data: this.jsonData.map(item => item.country),
			autocompleteElement: this.tripInput,
			autocompleteListElement: this.autocompleteList,
			selectedItemsContainer: this.autoCompleteSelected,
			selectType: "multiple",
			selectedItemsContainerTitle: 'Your travel destinations',
			maxSelectedItems: 4,
			onSelectedItemListChange: this.handleSelectedItemListChange.bind(this),
		});

		this.selectedItemsArray = selectedItemsArray;
	},

	handleSelectedItemListChange: function () {
		const autocompleteListItems = this.widget.querySelectorAll('.autocomplete__selected__item');
		this.autoCompleteListItems = autocompleteListItems;
		this.toggleDisplayButton(autocompleteListItems);
	},


	toggleDisplayButton: function (autocompleteListItems) {
		if (autocompleteListItems.length > 0) {
			this.continueButton.classList.remove('display-none');
		} else {
			this.continueButton.classList.add('display-none');
		}
	},

	handleButtonClick: function () {
		const nameList = Array.from(this.autoCompleteListItems)?.map(item => {
			const nameNode = item.querySelector('.autocomplete__selected__name');
			return nameNode.innerText;
		});

		// list of objects according to user choices - will be used to populate the accordions
		const visaAccordionList = this.filterVisaData(nameList);

		//loop through the list and create an accordion for each one
		visaAccordionList.forEach(listItem => this.createAccordionItems(listItem));

		// loop through the list and create pdf list items
		visaAccordionList.forEach(listItem => this.createPDFListItems(listItem));
	},

	filterVisaData: function (nameList) {
		return this.jsonData.filter(item => nameList.includes(item.country.trim()));
	},


	createPDFListItems: function (pdfData) {
		// clone the pdf list item template
		const pdfListItemClone = this.templatePdfListItem.content.cloneNode(true);

		const pdfTitle = pdfListItemClone.querySelector('.visa-tool__pdf__item__header');
		pdfTitle.textContent = `${pdfData.country}: ${pdfData.visa_requirements}`;

		if (pdfData.travelAdvised) {
			const costData = {
				visa_cost: pdfData.visa_cost || 0,
				visa_currency: pdfData.visa_currency || "GBP"
			};
			this.createCostRow(pdfListItemClone, costData);
		}

		if (pdfData.infomation) this.createInfoRow(pdfListItemClone, pdfData);
		this.createTravelWarningBox(pdfListItemClone, pdfData);

		this.pdfContentContainer.appendChild(pdfListItemClone);
	},

	createAccordionItems: function (accordionData) {
		// clone the accordion template
		const accordionClone = this.templateAccordion.content.cloneNode(true);

		const accordionTitle = accordionClone.querySelector('.accordion-title');
		accordionTitle.textContent = accordionData.country;

		// visa required text
		const visaRequiredText = accordionClone.querySelector('[data-visa-isRequired-text]');
		visaRequiredText.textContent = accordionData.visa_requirements;

		if (accordionData.travelAdvised) {
			const costData = {
				visa_cost: accordionData.visa_cost || 0,
				visa_currency: accordionData.visa_currency || "GBP"
			};
			this.createCostRow(accordionClone, costData);
		}

		if (accordionData.infomation) this.createInfoRow(accordionClone, accordionData);
		if (accordionData.visa_link) this.createStepsRow(accordionClone, accordionData);
		this.createTravelWarningBox(accordionClone, accordionData);

		// append to the accordion container
		this.accordionContainer.appendChild(accordionClone);
	},


	createCostRow: async function (clonedElement, data) {
		const visaCostRow = clonedElement.querySelector('[data-visa-row-cost]');
		const visaCostValue = visaCostRow.querySelector('[data-visa-row-cost-value]');

		// latter handles Ireland case
		const formatCurrency = sCurrencyFormatter(data.visa_cost, data.visa_currency, "en-GB", 'narrowSymbol');
		visaCostValue.textContent = formatCurrency;
		visaCostRow.classList.remove('display-none');
	},

	createInfoRow: function (clonedElement, data) {
		const infoRow = clonedElement.querySelector('[data-visa-row-info]');
		const infoValue = infoRow.querySelector('[data-visa-row-info-value]');
		infoValue.textContent = data.infomation;
		infoRow.classList.remove('display-none');
	},

	createStepsRow: function (clonedElement, data) {
		const stepsRow = clonedElement.querySelector('[data-visa-row-steps]');
		const stepsLink = stepsRow.querySelector('[data-visa-row-steps-link]');
		stepsLink.href = data.visa_link;
		stepsRow.classList.remove('display-none');
	},

	createDaysRow: function (clonedElement) {
		const visaDaysRow = clonedElement.querySelector('[data-visa-row-days]');
		const visaDaysValue = visaDaysRow.querySelector('[data-visa-row-days-value]');
		visaDaysValue.textContent = "0 days";
		visaDaysRow.classList.remove('display-none');
	},

	createTravelWarningBox: function (clonedElement, data) {
		const warningBoxContent = clonedElement.querySelector('[data-visa-warning-content]');
		const warningBoxTitle = clonedElement.querySelector('[data-visa-warning-title]');
		const warningBox = clonedElement.querySelector('.mod-tool-tip');

		warningBoxTitle.textContent = data.travelAdvised ? this.travelAdvisedTitle : this.travelInadvisedTitle;
		warningBoxContent.textContent = data.travelAdvised ? `${data.country} ${this.travelAdvisedContent}` : data.travel_Inadvised_Text;
		warningBox.classList.remove('display-none');
	},

	generatePDF: async function () {
		const container = document.getElementById('visa-tool-pdf');
		if (!container) return;

		container.classList.add('pdf__capture-only');
		container.classList.remove('display-none');

		const element = container.querySelector('.visa-tool__pdf');

		const pdfOptions = {
			margin: 16,
			filename: 'Confused.com-visa-requirements.pdf',
			image: { type: 'jpeg', quality: 0.98 },
			html2canvas: { scale: 2 },
			jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
		};

		html2pdf(element, pdfOptions);

		container.classList.remove('pdf__capture-only');
		container.classList.add('display-none');
	},

	resetWidget: function () {
		// Clear accordion container
		sBannerStep(1);
		sShowScreen(this.screens, 1);
		this.accordionContainer.innerHTML = '';
		this.pdfContentContainer.innerHTML = '';

		sResetAutocomplete(
			this.selectedItemsArray,
			this.autoCompleteSelected,
			this.tripInput,
			this.autocompleteList
		);
	}

};

document.addEventListener('DOMContentLoaded', function () {
	visaTool.init();
});